const preloadImage = (image: HTMLImageElement): void => {
  const imagePath = image.dataset.src;

  if (imagePath) {
    image.setAttribute('src', imagePath);
  }
};

const findChildImageElement = (element: Element): HTMLImageElement | null => {
  for (const child of element.childNodes) {
    if (child instanceof HTMLImageElement) {
      return child;
    }
  }

  return null;
};

/**
 * For use viewport intersection observer for image preloading
 * make sure to pass in observe method img html element
 * or element with img html element as 1-st level child
 * and set data-src attribute on img tag
 *
 * @type {IntersectionObserver}
 */
export const imagePreloaderObserver = new IntersectionObserver(
  (entries, self) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        const element = entry.target;

        if (element instanceof HTMLImageElement) {
          preloadImage(element);

          return self.unobserve(element);
        }

        const imageElement = findChildImageElement(element);

        if (imageElement) {
          preloadImage(imageElement);
        }

        self.unobserve(element);
      }
    });
  }
);
